var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.293,
    height: 27.293,
    viewBox: "0 0 27.293 27.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "schedule-svgrepo-com",
    d: "M25.2,4.729H23.834V3.365a1.365,1.365,0,1,0-2.729,0V4.729H10.188V3.365A1.289,1.289,0,0,0,8.823,2,1.289,1.289,0,0,0,7.459,3.365V4.729H6.094A4.021,4.021,0,0,0,2,8.823v1.365H29.293V8.823A4.021,4.021,0,0,0,25.2,4.729ZM2,25.2a4.021,4.021,0,0,0,4.094,4.094H25.2A4.021,4.021,0,0,0,29.293,25.2V12.917H2Zm20.47-9.553a1.365,1.365,0,1,1-1.365,1.365A1.289,1.289,0,0,1,22.47,15.646Zm0,5.459a1.365,1.365,0,1,1-1.365,1.365A1.289,1.289,0,0,1,22.47,21.105Zm-6.823-5.459a1.365,1.365,0,1,1-1.365,1.365A1.289,1.289,0,0,1,15.646,15.646Zm0,5.459a1.365,1.365,0,1,1-1.365,1.365A1.289,1.289,0,0,1,15.646,21.105ZM8.823,15.646a1.365,1.365,0,0,1,0,2.729,1.365,1.365,0,1,1,0-2.729Zm0,5.459a1.365,1.365,0,1,1,0,2.729,1.365,1.365,0,1,1,0-2.729Z",
    transform: "translate(-2 -2)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.4000f53ab22dd18e1881a116d7e9bddc.svg";
export { ForwardRef as ReactComponent };